import { apiRequest } from '../../api/http';
import { readTokens } from '../../auth/tokens';
const inFlight = new Set<string>();
export async function triggerAdminVisitDiscovery(adminId: string) {
  if (!adminId || !readTokens()?.access_token || document.visibilityState !== 'visible' || inFlight.has(adminId)) return;
  // App entry / focus triggers all due checks, regardless of which admin enters.
  // Daily event IDs and server leases prevent duplicate sends across admins.
  inFlight.add(adminId);
  try { await apiRequest('/admin/notifications/inactivity-reminders/trigger', {method: 'POST'}); }
  catch { /* Opportunistic work must not interrupt admin navigation. */ }
  finally { inFlight.delete(adminId); }
}
